export default 
`
<svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_79242_325552)">
<circle cx="34" cy="34" r="34" fill="currentColor"/>
<path d="M52.4027 20H20.9463C16.8898 20 13.5249 21.9675 12.5761 24.895L9 35.9027H30.1953C30.1953 35.9027 32.238 29.6097 32.4267 29.0337H50.1L53.0335 20H52.4027ZM13.4457 25.179C14.2599 22.6684 17.3451 20.9153 20.9463 20.9153H51.7706C51.4513 21.9004 49.6078 27.5792 49.4323 28.1184H31.7603C31.7603 28.1184 29.715 34.4126 29.5289 34.9887H10.2602C10.6059 33.9234 13.4457 25.1803 13.4457 25.1803" fill="currentColor" />
<path d="M38.3543 32.0973H38.0218C38.0218 32.0973 35.9804 38.3902 35.7904 38.9663H18.1184L15.1836 48H47.2708C51.3272 48 54.6922 46.0338 55.6423 43.1037L59.2158 32.0973H38.3543ZM57.9569 33.0139C57.6125 34.0779 54.7714 42.8209 54.7714 42.8209C53.9572 45.3302 50.872 47.0846 47.2708 47.0846H16.4451C16.7658 46.0996 18.6093 40.4221 18.7834 39.8816H36.4581C36.4581 39.8816 38.5008 33.5887 38.6895 33.0126H57.9582L57.9569 33.0139Z" fill="currentColor" />
</g>
<defs>
<clipPath id="clip0_79242_325552">
<rect width="68" height="68" rx="34" fill="currentColor"/>
</clipPath>
</defs>
</svg>
`
